import { Grid, Typography, Box } from "@mui/material"
import Stack from "@mui/material/Stack"
import { gearDepartmentNumbers } from "../../../config"

import { BaseLineFooterStyles, ControlLargeBlankStyles, ControlSmallBlankStyles, FooterBoxStyles, FooterContentRightStyles, FooterContentStyles, InitialsStyles, LargeBlankStyles, OperatorInitStyles, OpInstructionsStyles, PaddingLargeStyles, PaddingStyles, PQFandDateStyles, SmallBlankStyles } from "./styles/OutputStyles"

function InProcessFooter({ output }) {
    return (
        <Box>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={FooterBoxStyles}
            >
                <Grid item sx={BaseLineFooterStyles}>
                    <Typography
                        multiline
                        variant="subtitle1"
                        sx={FooterContentStyles}
                    >
                        Baseline:
                    </Typography>
                </Grid>
                <Grid item sx={PaddingStyles}>
                    <Stack>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                        >
                            1) Less than .0005 Tolerance: -Supermic
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                        >
                            .0006 thru .003 Tolerance: Tenth Mic for OD .xxxx
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentRightStyles}
                            align="right"
                        >
                            Mic/Height Gages for Lengths .xxx
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                            align="left"
                        >
                            2) More than .003 Tolerance: Caliper for OD, ID,
                            Dim, Length .xxx, .x
                        </Typography>
                    </Stack>
                </Grid>
                <Grid item sx={PaddingStyles}>
                    <Stack>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                        >
                            3) Radius: Comparator / Radius Gage
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                        >
                            4) Surface Finish: Profilometer / Surface Comparator
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                            align="left"
                        >
                            5) Runout / Concentricity: Tenth Indicator / Centers
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                            align="left"
                        >
                            6) Parallel / Square: Tenth Indicator
                        </Typography>
                    </Stack>
                </Grid>
                <Grid item sx={PaddingStyles}>
                    <Stack>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                            align="left"
                        >
                            7) Chamfers: Comparator
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                            align="left"
                        >
                            8) True Position: CMM / Vision System
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                            align="left"
                        >
                            9) Internal Threads / Spline: Thread / Spline Plug
                            Gage
                        </Typography>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                            align="left"
                        >
                            10) External Threads / Spline: Thread / Spline Ring
                            Gage
                        </Typography>
                    </Stack>
                </Grid>
                <Grid item sx={PaddingLargeStyles}>
                    <Stack>
                        <Typography
                            multiline
                            variant="subtitle1"
                            sx={FooterContentStyles}
                            align="left"
                        >
                            11) The acceptable method of hole diameter
                            acceptance for holes larger than .375 dia with a
                            .0003 tolerance max is to use Sunnen Gage, Air Gage,
                            or Bore Gages to inspect for size, taper, and out of
                            round conditions. For holes less than .375 dia,
                            Go-No Go pins are acceptable except for product
                            using pins for acceptance in which pins utilized
                            more than 500X, carbide pins must be used.
                        </Typography>
                    </Stack>
                </Grid>
            </Grid>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="stretch"
            >
                <Grid item sx={OperatorInitStyles}>
                    <Typography
                        multiline
                        variant="subtitle1"
                        sx={InitialsStyles}
                    >
                        Operator's Initials or Inspector Stamp
                    </Typography>
                </Grid>
                {output.ppap ? (
                    <>
                        <Grid item sx={ControlLargeBlankStyles}></Grid>
                        <Grid item sx={ControlSmallBlankStyles}></Grid>
                        <Grid item sx={ControlSmallBlankStyles}></Grid>
                        <Grid item sx={ControlSmallBlankStyles}></Grid>
                        <Grid item sx={ControlSmallBlankStyles}></Grid>
                        <Grid item sx={ControlSmallBlankStyles}></Grid>
                    </>
                ) : (
                    <>
                        <Grid item sx={LargeBlankStyles}></Grid>
                        <Grid item sx={SmallBlankStyles}></Grid>
                        <Grid item sx={SmallBlankStyles}></Grid>
                        <Grid item sx={SmallBlankStyles}></Grid>
                        <Grid item sx={SmallBlankStyles}></Grid>
                        <Grid item sx={SmallBlankStyles}></Grid>
                    </>
                )}
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                {output.ppap ? (
                    <Typography
                        multiline
                        variant="subtitle1"
                        sx={OpInstructionsStyles}
                    >
                        If There Are No Frequency Callouts, Operator Inspects
                        All Dimensions Twice (2) per shift and Records Actual
                        Readings
                    </Typography>
                ) : (
                    <Typography
                        multiline
                        variant="subtitle1"
                        sx={OpInstructionsStyles}
                    >
                        Operator Inspects All Dimensions Twice (2) per shift and
                        Records Actual Readings
                    </Typography>
                )}
            </Grid>

            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
            >
                <Typography
                    multiline
                    variant="subtitle1"
                    sx={PQFandDateStyles}
                >
                    {gearDepartmentNumbers.includes(output.department.trim())
                        ? output.ppap
                            ? "PQF 1010-22 Rev 4"
                            : "PQF 1010-23 Rev 4"
                        : output.ppap
                        ? "PQF 1010-09 Rev 8"
                        : "PQF 1010-07 Rev 13"}
                </Typography>
                {output.ppap ? (
                    <Typography
                        multiline
                        variant="subtitle1"
                        sx={PQFandDateStyles}
                    >
                        If Required PPK/CPK Is Not Achieved, 100% Read & Record
                        Is Required.
                    </Typography>
                ) : null}
                <Typography
                    multiline
                    variant="subtitle1"
                    sx={PQFandDateStyles}
                >
                    {new Date().toLocaleDateString("en-US", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                    })}
                </Typography>
            </Grid>
        </Box>
    )
}

export default InProcessFooter
